import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-review',
  templateUrl: './invoice-review.component.html',
  styleUrls: ['./invoice-review.component.css']
})
export class InvoiceReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
